<template>
  <aside class="sidebar" aria-label="On this page">
    <p class="sidebar-label">On this page</p>
    <ul class="sidebar-nav" ref="sidebarNav">
      <li v-for="s in sections" :key="'s-' + s.id">
        <a
          :href="'#' + s.id"
          :class="{ active: activeId === s.id }"
          @click.prevent="$emit('navigate', s.id)"
          >{{ s.long }}</a
        >
      </li>
    </ul>
  </aside>
</template>

<script>
export default {
  name: "DeliverySidebar",
  props: {
    sections: {
      type: Array,
      required: true,
    },
    activeId: {
      type: String,
      required: true,
    },
  },
  emits: ["navigate"],
  methods: {
    scrollActiveIntoView() {
      const nav = this.$refs.sidebarNav;
      if (!nav || nav.scrollWidth <= nav.clientWidth) return;
      const active = nav.querySelector("a.active");
      if (!active) return;
      nav.scrollLeft =
        active.offsetLeft - nav.offsetWidth / 2 + active.offsetWidth / 2;
    },
  },
  watch: {
    activeId() {
      this.$nextTick(() => this.scrollActiveIntoView());
    },
  },
};
</script>
